import { api } from 'data/api/api'

import { GetNationalitiesResp } from '../types/nationality'

export const getNationalities = () => api.get<GetNationalitiesResp>('/nationalities')
